module.exports = __webpack_public_path__ + "img/s.96634dfb.jpg";